
import { jsPDF } from "jspdf";
import { PdfFooterOptions } from "../types";

/**
 * Add footer
 */
export const addFooter = (doc: jsPDF, { companyName, pageWidth, footerY, colors }: PdfFooterOptions): void => {
  // Using techne-primaryPurple color from the theme
  doc.setFontSize(8); // Smaller font size
  doc.setTextColor(colors?.primaryPurple[0] || 103, colors?.primaryPurple[1] || 36, colors?.primaryPurple[2] || 125);
  doc.text("Copyright BoardSight AI | boardsight.ai | info@techne.ai", pageWidth / 2, footerY, { align: "center" });
  doc.text("Confidential - For " + companyName + " only", pageWidth / 2, footerY + 5, { align: "center" });
};
